import { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { a11yProps, sizeTab } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { CustomTabPanel } from "@/erp/sale";
import RecepcionCompraFinalizadoPage from "../shared/component/RecepcionCompraFinalizado";
import RecepcionCompraAbiertoPage from "../shared/component/RecepcionCompraAbiertoPage";
//import RecepcionFinalizadaPagina from "../shared/component/RecepcionCompraFinalizada";



export default function RecepcionCompraPage() {


  const [valueTab, setValueTab] = useState(0);

  return (

    <>
      <SingleTableBoxScene title={"Recepción de Mercadería"}
        enableRedirect={true}
        visibleReport={true}
      >

        <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
          <Tabs
            value={valueTab}
            onChange={(_event: React.SyntheticEvent, newValue: number) => {
              setValueTab(newValue);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="scrollable force tabs preventa"
          >
            <Tab label={"Abierto"}{...a11yProps} />
            <Tab label={'Finalizadas'} {...a11yProps(1)} />

          </Tabs>
        </Box>
        <CustomTabPanel value={valueTab} index={0}>
          <RecepcionCompraAbiertoPage/>
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={1}>
          <RecepcionCompraFinalizadoPage />
        </CustomTabPanel>
      </SingleTableBoxScene >


    </>


  );


}